import React from 'react';
import PropTypes from 'prop-types';
import TemplateRoot from 'components/Layout/SiteOneTemplate';

const listTypes = {
  suspended: 'The company associated with your account has been suspended. Please contact your administrator for more information.',
  error404: 'Page Not Found.',
  general: 'Something is wrong.'
};

export default class ErrorPage extends React.Component {
  static propTypes = {
    errorType: PropTypes.any
  }

  render() {
    const redirectUrl = window.profile.clientName
      ? `http://${window.location.host}`
      : `http://${window.location.host.split('.')[1]}`;

    return (
      <TemplateRoot>
        <div className='box-form-siteone login-form invalid-error' style={{ width: '60%', maxWidth: 600 }}>
          <h3>Error</h3>
          <div className='text-danger error-message'>
            {listTypes[this.props.errorType]}
          </div>
          <div>
            <a
              className='btn btn-primary btn-siteone-default'
              href={redirectUrl}>Go to home</a>
          </div>
        </div>
      </TemplateRoot>
    );
  }

}



// WEBPACK FOOTER //
// ./src/errorPage/ErrorPage.js